export default __webpack_public_path__ + "static/media/01.13d23fdd.png";